import React from "react";

export const ModalBody = ({ children, data }) => {
  return <div>{children || data}</div>;
};
